import { render, staticRenderFns } from "./AddDashCollectionDialog.vue?vue&type=template&id=2ba5940d"
import script from "./AddDashCollectionDialog.vue?vue&type=script&lang=js"
export * from "./AddDashCollectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports